import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactSection = () => {
  return (
    <>
      {/* PAGE HEADER */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  Contact Us
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT INFO */}
      <section className="contact-one section-space">
        <div className="container">
          <div className="row gutter-y-30">

            {/* QUICK CONTACT */}
            <div className="col-12 col-md-4">
              <div
                className="contact-one__item wow fadeInLeft"
                data-wow-duration="1700ms"
              >
                <div className="contact-one__item__icon">
                  <FaPhoneAlt size={32} />
                </div>
                <div className="contact-one__item__content">
                  <h5 className="contact-one__item__title">Quick Contact</h5>
                  <a href="tel:+917387507373" className="contact-one__item__call">
                    +91 7387507373
                  </a>
                  <a href="tel:+919595532929" className="contact-one__item__call">
                    +91 9595532929
                  </a>
                </div>
              </div>
            </div>

            {/* EMAIL */}
            <div className="col-12 col-md-4">
              <div
                className="contact-one__item wow fadeInLeft"
                data-wow-duration="1900ms"
              >
                <div className="contact-one__item__icon">
                  <FaEnvelope size={32} />
                </div>
                <div className="contact-one__item__content">
                  <h5 className="contact-one__item__title">Support Email</h5>
                  <a
                    href="mailto:booking@sanavitravels.com"
                    className="contact-one__item__call"
                  >
                    booking@sanavitravels.com
                  </a>
                </div>
              </div>
            </div>

            {/* ADDRESS */}
            <div className="col-12 col-md-4">
              <div
                className="contact-one__item wow fadeInLeft"
                data-wow-duration="1500ms"
              >
                <div className="contact-one__item__icon">
                  <FaMapMarkerAlt size={32} />
                </div>
                <div className="contact-one__item__content">
                  <h5 className="contact-one__item__title">Address</h5>
                  <p className="contact-one__item__text">
                    OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                    SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                    DIST PUNE – 412215
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* GOOGLE MAP */}
      <div className="contact-map">
        <div className="google-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6554.388190899338!2d74.40857!3d18.447861!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc317807bdc9d0b%3A0x6724a87fdd5a3066!2sSanavi%20Travels!5e1!3m2!1sen!2sin!4v1768580424861!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Sanavi Travels Location"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default ContactSection;
